"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
define('uikit/templates',['handlebars'], function (Handlebars) {
  this["Handlebars"] = this["Handlebars"] || {};
  this["Handlebars"]["UIKit"] = this["Handlebars"]["UIKit"] || {};
  this["Handlebars"]["UIKit"]["accordion"] = Handlebars.template({
    "1": function _(depth0, helpers, partials, data) {
      var stack1,
        helper,
        lambda = this.lambda,
        escapeExpression = this.escapeExpression,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        buffer = "  <div class=\"title\" data-index=\"" + escapeExpression(lambda(data && data.index, depth0)) + "\">\n    <i class=\"";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.icon : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(2, data),
        "inverse": this.program(4, data),
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer + " icon\"></i>\n    " + escapeExpression((helper = (helper = helpers.text || (depth0 != null ? depth0.text : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "text",
        "hash": {},
        "data": data
      }) : helper)) + "\n  </div>\n  <div class=\"content\"></div>\n";
    },
    "2": function _(depth0, helpers, partials, data) {
      var helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression;
      return escapeExpression((helper = (helper = helpers.icon || (depth0 != null ? depth0.icon : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "icon",
        "hash": {},
        "data": data
      }) : helper));
    },
    "4": function _(depth0, helpers, partials, data) {
      return "dropdown";
    },
    "compiler": [6, ">= 2.0.0-beta.1"],
    "main": function main(depth0, helpers, partials, data) {
      var stack1,
        buffer = "";
      stack1 = helpers.each.call(depth0, depth0 != null ? depth0.items : depth0, {
        "name": "each",
        "hash": {},
        "fn": this.program(1, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer;
    },
    "useData": true
  });
  this["Handlebars"]["UIKit"]["breadcrumb"] = Handlebars.template({
    "1": function _(depth0, helpers, partials, data) {
      var stack1,
        buffer = "";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.link : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(2, data),
        "inverse": this.program(5, data),
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      stack1 = helpers.unless.call(depth0, depth0 != null ? depth0.last : depth0, {
        "name": "unless",
        "hash": {},
        "fn": this.program(7, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer;
    },
    "2": function _(depth0, helpers, partials, data) {
      var stack1,
        helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression,
        buffer = "    <a class=\"section\" ";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.href : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(3, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer + " data-index=\"" + escapeExpression((helper = (helper = helpers.index || (depth0 != null ? depth0.index : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "index",
        "hash": {},
        "data": data
      }) : helper)) + "\" tabindex=\"0\">" + escapeExpression((helper = (helper = helpers.text || (depth0 != null ? depth0.text : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "text",
        "hash": {},
        "data": data
      }) : helper)) + "</a>\n";
    },
    "3": function _(depth0, helpers, partials, data) {
      var helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression;
      return "href=\"" + escapeExpression((helper = (helper = helpers.href || (depth0 != null ? depth0.href : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "href",
        "hash": {},
        "data": data
      }) : helper)) + "\"";
    },
    "5": function _(depth0, helpers, partials, data) {
      var helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression;
      return "    <div class=\"section\" data-index=\"" + escapeExpression((helper = (helper = helpers.index || (depth0 != null ? depth0.index : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "index",
        "hash": {},
        "data": data
      }) : helper)) + "\">" + escapeExpression((helper = (helper = helpers.text || (depth0 != null ? depth0.text : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "text",
        "hash": {},
        "data": data
      }) : helper)) + "</div>\n";
    },
    "7": function _(depth0, helpers, partials, data) {
      var stack1,
        buffer = "";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.dividerIcon : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(8, data),
        "inverse": this.program(10, data),
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer;
    },
    "8": function _(depth0, helpers, partials, data) {
      var helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression;
      return "        <i class=\"" + escapeExpression((helper = (helper = helpers.dividerIcon || (depth0 != null ? depth0.dividerIcon : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "dividerIcon",
        "hash": {},
        "data": data
      }) : helper)) + " icon divider\"></i>\n";
    },
    "10": function _(depth0, helpers, partials, data) {
      var helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression;
      return "        <div class=\"divider\"> " + escapeExpression((helper = (helper = helpers.divider || (depth0 != null ? depth0.divider : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "divider",
        "hash": {},
        "data": data
      }) : helper)) + " </div>\n";
    },
    "compiler": [6, ">= 2.0.0-beta.1"],
    "main": function main(depth0, helpers, partials, data) {
      var stack1,
        buffer = "";
      stack1 = helpers.each.call(depth0, depth0 != null ? depth0.items : depth0, {
        "name": "each",
        "hash": {},
        "fn": this.program(1, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer;
    },
    "useData": true
  });
  this["Handlebars"]["UIKit"]["button"] = Handlebars.template({
    "1": function _(depth0, helpers, partials, data) {
      var stack1,
        buffer = "";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.icon : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(2, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer;
    },
    "2": function _(depth0, helpers, partials, data) {
      var helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression;
      return "  <i class=\"" + escapeExpression((helper = (helper = helpers.icon || (depth0 != null ? depth0.icon : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "icon",
        "hash": {},
        "data": data
      }) : helper)) + " icon\"></i>\n";
    },
    "4": function _(depth0, helpers, partials, data) {
      var helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression;
      return "  " + escapeExpression((helper = (helper = helpers.text || (depth0 != null ? depth0.text : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "text",
        "hash": {},
        "data": data
      }) : helper)) + "\n";
    },
    "compiler": [6, ">= 2.0.0-beta.1"],
    "main": function main(depth0, helpers, partials, data) {
      var stack1,
        buffer = "";
      stack1 = helpers.unless.call(depth0, depth0 != null ? depth0.iconRight : depth0, {
        "name": "unless",
        "hash": {},
        "fn": this.program(1, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += "\n";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.text : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(4, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += "\n";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.iconRight : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(1, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer;
    },
    "useData": true
  });
  this["Handlebars"]["UIKit"]["calendar.appointment"] = Handlebars.template({
    "compiler": [6, ">= 2.0.0-beta.1"],
    "main": function main(depth0, helpers, partials, data) {
      var helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression;
      return "<div class=\"time\">" + escapeExpression((helper = (helper = helpers.time || (depth0 != null ? depth0.time : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "time",
        "hash": {},
        "data": data
      }) : helper)) + "</div>\n<div class=\"text\">" + escapeExpression((helper = (helper = helpers.text || (depth0 != null ? depth0.text : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "text",
        "hash": {},
        "data": data
      }) : helper)) + "</div>";
    },
    "useData": true
  });
  this["Handlebars"]["UIKit"]["calendar.cell"] = Handlebars.template({
    "1": function _(depth0, helpers, partials, data) {
      return "        <div class=\"appointment\"></div>\n";
    },
    "compiler": [6, ">= 2.0.0-beta.1"],
    "main": function main(depth0, helpers, partials, data) {
      var stack1,
        helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression,
        buffer = "<div class=\"text\">" + escapeExpression((helper = (helper = helpers.date || (depth0 != null ? depth0.date : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
          "name": "date",
          "hash": {},
          "data": data
        }) : helper)) + "</div>\n<table role=\"presentation\">\n  <tr>\n    <td>\n";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.appointment : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(1, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer + "      <div class=\"appointments\"></div>\n    </td>\n  </tr>\n</table>\n<ui name=\"label\"></ui>\n";
    },
    "useData": true
  });
  this["Handlebars"]["UIKit"]["calendar.cell.more"] = Handlebars.template({
    "compiler": [6, ">= 2.0.0-beta.1"],
    "main": function main(depth0, helpers, partials, data) {
      return "<i class=\"icon chevron down large\"></i>";
    },
    "useData": true
  });
  this["Handlebars"]["UIKit"]["calendar.date.display.dropdown"] = Handlebars.template({
    "compiler": [6, ">= 2.0.0-beta.1"],
    "main": function main(depth0, helpers, partials, data) {
      return "<span class=\"month\"><ui name=\"monthView\"></ui></span> \n<span class=\"year\"><ui name=\"yearView\"></ui></span>";
    },
    "useData": true
  });
  this["Handlebars"]["UIKit"]["calendar.date.display"] = Handlebars.template({
    "compiler": [6, ">= 2.0.0-beta.1"],
    "main": function main(depth0, helpers, partials, data) {
      var helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression;
      return "<span class=\"month\">" + escapeExpression((helper = (helper = helpers.month || (depth0 != null ? depth0.month : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "month",
        "hash": {},
        "data": data
      }) : helper)) + "</span> \n<span class=\"year\">" + escapeExpression((helper = (helper = helpers.year || (depth0 != null ? depth0.year : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "year",
        "hash": {},
        "data": data
      }) : helper)) + "</span>";
    },
    "useData": true
  });
  this["Handlebars"]["UIKit"]["calendar.default.controls"] = Handlebars.template({
    "compiler": [6, ">= 2.0.0-beta.1"],
    "main": function main(depth0, helpers, partials, data) {
      return "<table role=\"presentation\" style=\"width: 100%; table-layout: fixed;\">\n  <tr>\n    <td style=\"width: 1px;\" class=\"left wrapper\">\n      <ui name=\"left\" />\n    </td>\n    <td>\n      <table role=\"presentation\">\n        <tr>\n          <td class=\"previous\">\n            <div class=\"control\">\n              <i class=\"chevron left icon\" tabindex=\"0\" role=button\" aria-label=\"Previous month\"></i>\n            </div>\n          </td>\n          <td class=\"title\">\n            <ui name=\"content\" />\n          </td>\n          <td class=\"next\">\n            <div class=\"control\">\n              <i class=\"chevron right icon\" tabindex=\"0\" role=button\" aria-label=\"Next month\"></i>\n            </div>\n          </td>\n        </tr>\n      </table>\n    </td>\n    <td style=\"width: 1px;\" class=\"right wrapper\">\n      <div style=\"float: right;\">\n        <ui name=\"right\" />\n      </div>\n    </td>\n  </tr>\n</table>\n";
    },
    "useData": true
  });
  this["Handlebars"]["UIKit"]["calendar"] = Handlebars.template({
    "compiler": [6, ">= 2.0.0-beta.1"],
    "main": function main(depth0, helpers, partials, data) {
      return "<ui name=\"controls\"></ui>\n<ui name=\"content\"></ui>\n";
    },
    "useData": true
  });
  this["Handlebars"]["UIKit"]["calendar.week.appointment"] = Handlebars.template({
    "compiler": [6, ">= 2.0.0-beta.1"],
    "main": function main(depth0, helpers, partials, data) {
      var helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression;
      return "<table role=\"presentation\" class=\"layout full height\">\n  <tbody>\n    <tr>\n      <td class=\"collapsing\">\n        <div class=\"time\">" + escapeExpression((helper = (helper = helpers.time || (depth0 != null ? depth0.time : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "time",
        "hash": {},
        "data": data
      }) : helper)) + "</div>\n      </td>\n      <td>\n        <div class=\"text\">" + escapeExpression((helper = (helper = helpers.text || (depth0 != null ? depth0.text : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "text",
        "hash": {},
        "data": data
      }) : helper)) + "</div>\n      </td>\n    </tr>\n  </tbody>\n</table>\n";
    },
    "useData": true
  });
  this["Handlebars"]["UIKit"]["calendar.week.appointment.list"] = Handlebars.template({
    "compiler": [6, ">= 2.0.0-beta.1"],
    "main": function main(depth0, helpers, partials, data) {
      return "<div class=\"position layout list\"></div>";
    },
    "useData": true
  });
  this["Handlebars"]["UIKit"]["calendar.week.day.cell"] = Handlebars.template({
    "compiler": [6, ">= 2.0.0-beta.1"],
    "main": function main(depth0, helpers, partials, data) {
      var helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression;
      return escapeExpression((helper = (helper = helpers.text || (depth0 != null ? depth0.text : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "text",
        "hash": {},
        "data": data
      }) : helper));
    },
    "useData": true
  });
  this["Handlebars"]["UIKit"]["calendar.week"] = Handlebars.template({
    "1": function _(depth0, helpers, partials, data, depths) {
      var stack1,
        helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression,
        buffer = "                    <tr class=\"minor interval\">\n                      <td class=\"time gutter\">\n                        &nbsp;\n                      </td>\n";
      stack1 = helpers.each.call(depth0, depths[1] != null ? depths[1].weekdays : depths[1], {
        "name": "each",
        "hash": {},
        "fn": this.program(2, data, depths),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += "                    </tr>\n                    <tr class=\"major interval\">\n                      <td class=\"time gutter\"><div class=\"text\">" + escapeExpression((helper = (helper = helpers.text || (depth0 != null ? depth0.text : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "text",
        "hash": {},
        "data": data
      }) : helper)) + "</div></td>\n";
      stack1 = helpers.each.call(depth0, depths[1] != null ? depths[1].weekdays : depths[1], {
        "name": "each",
        "hash": {},
        "fn": this.program(2, data, depths),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer + "                    </tr>\n";
    },
    "2": function _(depth0, helpers, partials, data, depths) {
      var stack1,
        buffer = "                        <td class=\"time interval ";
      stack1 = helpers['if'].call(depth0, depths[1] != null ? depths[1].businessHour : depths[1], {
        "name": "if",
        "hash": {},
        "fn": this.program(3, data, depths),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer + "\"></td>\n";
    },
    "3": function _(depth0, helpers, partials, data) {
      return "business";
    },
    "compiler": [6, ">= 2.0.0-beta.1"],
    "main": function main(depth0, helpers, partials, data, depths) {
      var stack1,
        helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression,
        buffer = "<div class=\"wrapper\">\n  <table role=\"presentation\" class=\"layout fixed full height\">\n    <thead>\n      <tr>\n        <td class=\"calendarheader\">\n          <div style=\"margin-right: " + escapeExpression((helper = (helper = helpers.scrollbarWidth || (depth0 != null ? depth0.scrollbarWidth : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
          "name": "scrollbarWidth",
          "hash": {},
          "data": data
        }) : helper)) + "px;\">\n            <ui name=\"controls\"></ui>\n          </div>\n          <div style=\"margin-right: " + escapeExpression((helper = (helper = helpers.scrollbarWidth || (depth0 != null ? depth0.scrollbarWidth : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
          "name": "scrollbarWidth",
          "hash": {},
          "data": data
        }) : helper)) + "px;\">\n          <table role=\"presentation\" class=\"layout fixed\">\n            <thead>\n              <tr class=\"header\">\n                <th class=\"time gutter\"></th>\n              </tr>\n            </thead>\n          </table>\n          </div>\n        </td>\n      </tr>\n    </thead>\n    <tbody>\n      <tr>\n        <td>\n          <div class=\"scroller\">\n            <div class=\"time grid\">\n              <table role=\"presentation\" class=\"layout fixed\">\n                <tbody>\n";
      stack1 = helpers.each.call(depth0, depth0 != null ? depth0.hours : depth0, {
        "name": "each",
        "hash": {},
        "fn": this.program(1, data, depths),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer + "                </tbody>\n              </table>\n            </div>\n            <div class=\"appointment layout\">\n              <table role=\"presentation\" class=\"layout fixed\">\n                <tbody>\n                  <tr class=\"appointments\">\n                    <td class=\"time gutter\"></td>\n                  </tr>\n                </tbody>\n              </table>\n            </div>\n          </div>\n        </td>\n      </tr>\n    </tbody>\n  </table>\n</div>\n";
    },
    "useData": true,
    "useDepths": true
  });
  this["Handlebars"]["UIKit"]["calendar.week.popup"] = Handlebars.template({
    "compiler": [6, ">= 2.0.0-beta.1"],
    "main": function main(depth0, helpers, partials, data) {
      return "<div class=\"ui basic buttons two fluid\" style=\"margin-bottom: 1em;\">\n  <ui name=\"monthButton\"></ui>\n  <ui name=\"yearButton\"></ui>\n</div>\n<div>\n  <ui name=\"yearGrid\"></ui>\n</div>\n<div>\n  <ui name=\"monthGrid\"></ui>\n</div>";
    },
    "useData": true
  });
  this["Handlebars"]["UIKit"]["checkbox"] = Handlebars.template({
    "1": function _(depth0, helpers, partials, data) {
      return "radio";
    },
    "3": function _(depth0, helpers, partials, data) {
      return "checkbox";
    },
    "5": function _(depth0, helpers, partials, data) {
      return "checked=\"checked\"";
    },
    "7": function _(depth0, helpers, partials, data) {
      return "disabled=\"disabled\"";
    },
    "9": function _(depth0, helpers, partials, data) {
      return "    <ui name=\"input\" />\n";
    },
    "11": function _(depth0, helpers, partials, data) {
      var helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression;
      return "    " + escapeExpression((helper = (helper = helpers.text || (depth0 != null ? depth0.text : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "text",
        "hash": {},
        "data": data
      }) : helper)) + "\n";
    },
    "compiler": [6, ">= 2.0.0-beta.1"],
    "main": function main(depth0, helpers, partials, data) {
      var stack1,
        helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression,
        buffer = "<input type=\"";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.radio : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(1, data),
        "inverse": this.program(3, data),
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += "\" name=\"" + escapeExpression((helper = (helper = helpers.name || (depth0 != null ? depth0.name : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "name",
        "hash": {},
        "data": data
      }) : helper)) + "\" ";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.value : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(5, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += " ";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.disabled : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(7, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += ">\n<label>\n";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.input : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(9, data),
        "inverse": this.program(11, data),
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer + "</label>";
    },
    "useData": true
  });
  this["Handlebars"]["UIKit"]["default.popup"] = Handlebars.template({
    "1": function _(depth0, helpers, partials, data) {
      var helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression;
      return "<div class=\"header\">" + escapeExpression((helper = (helper = helpers.header || (depth0 != null ? depth0.header : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "header",
        "hash": {},
        "data": data
      }) : helper)) + "</div>\n";
    },
    "3": function _(depth0, helpers, partials, data) {
      var helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression;
      return "<div class=\"content\">" + escapeExpression((helper = (helper = helpers.text || (depth0 != null ? depth0.text : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "text",
        "hash": {},
        "data": data
      }) : helper)) + "</div>\n";
    },
    "compiler": [6, ">= 2.0.0-beta.1"],
    "main": function main(depth0, helpers, partials, data) {
      var stack1,
        buffer = "";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.header : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(1, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.text : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(3, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer;
    },
    "useData": true
  });
  this["Handlebars"]["UIKit"]["dimmer"] = Handlebars.template({
    "1": function _(depth0, helpers, partials, data) {
      return "<div class=\"content\">\n  <div class=\"center\"><ui name=\"content\"></ui></div>\n</div>\n";
    },
    "3": function _(depth0, helpers, partials, data) {
      return "  <ui name=\"content\"></ui>\n";
    },
    "compiler": [6, ">= 2.0.0-beta.1"],
    "main": function main(depth0, helpers, partials, data) {
      var stack1,
        buffer = "";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.centered : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(1, data),
        "inverse": this.program(3, data),
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer;
    },
    "useData": true
  });
  this["Handlebars"]["UIKit"]["divider"] = Handlebars.template({
    "1": function _(depth0, helpers, partials, data) {
      var helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression;
      return "  <i class=\"" + escapeExpression((helper = (helper = helpers.icon || (depth0 != null ? depth0.icon : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "icon",
        "hash": {},
        "data": data
      }) : helper)) + " icon\"></i>\n";
    },
    "compiler": [6, ">= 2.0.0-beta.1"],
    "main": function main(depth0, helpers, partials, data) {
      var stack1,
        helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression,
        buffer = "";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.icon : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(1, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer + escapeExpression((helper = (helper = helpers.text || (depth0 != null ? depth0.text : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "text",
        "hash": {},
        "data": data
      }) : helper));
    },
    "useData": true
  });
  this["Handlebars"]["UIKit"]["dropdown"] = Handlebars.template({
    "1": function _(depth0, helpers, partials, data) {
      var stack1,
        buffer = "";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.icon : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(2, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer;
    },
    "2": function _(depth0, helpers, partials, data) {
      var helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression;
      return "  <i class=\"" + escapeExpression((helper = (helper = helpers.icon || (depth0 != null ? depth0.icon : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "icon",
        "hash": {},
        "data": data
      }) : helper)) + " icon " + escapeExpression((helper = (helper = helpers.textColor || (depth0 != null ? depth0.textColor : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "textColor",
        "hash": {},
        "data": data
      }) : helper)) + "\"></i>\n";
    },
    "4": function _(depth0, helpers, partials, data) {
      var helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression;
      return "  <div id=\"" + escapeExpression((helper = (helper = helpers.htmlId || (depth0 != null ? depth0.htmlId : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "htmlId",
        "hash": {},
        "data": data
      }) : helper)) + "Header\" class=\"header\">" + escapeExpression((helper = (helper = helpers.header || (depth0 != null ? depth0.header : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "header",
        "hash": {},
        "data": data
      }) : helper)) + "</div>\n";
    },
    "6": function _(depth0, helpers, partials, data) {
      var stack1,
        buffer = "";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.text : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(7, data),
        "inverse": this.program(10, data),
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer;
    },
    "7": function _(depth0, helpers, partials, data) {
      var stack1,
        buffer = "";
      stack1 = helpers.unless.call(depth0, depth0 != null ? depth0.iconOnly : depth0, {
        "name": "unless",
        "hash": {},
        "fn": this.program(8, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer;
    },
    "8": function _(depth0, helpers, partials, data) {
      var helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression;
      return "  <div id=\"" + escapeExpression((helper = (helper = helpers.htmlId || (depth0 != null ? depth0.htmlId : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "htmlId",
        "hash": {},
        "data": data
      }) : helper)) + "Text\" class=\"text " + escapeExpression((helper = (helper = helpers.textColor || (depth0 != null ? depth0.textColor : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "textColor",
        "hash": {},
        "data": data
      }) : helper)) + "\">\n    " + escapeExpression((helper = (helper = helpers.text || (depth0 != null ? depth0.text : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "text",
        "hash": {},
        "data": data
      }) : helper)) + "\n  </div>\n";
    },
    "10": function _(depth0, helpers, partials, data) {
      var stack1,
        buffer = "";
      stack1 = helpers.unless.call(depth0, depth0 != null ? depth0.iconOnly : depth0, {
        "name": "unless",
        "hash": {},
        "fn": this.program(11, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer;
    },
    "11": function _(depth0, helpers, partials, data) {
      var helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression;
      return "    <div id=\"" + escapeExpression((helper = (helper = helpers.htmlId || (depth0 != null ? depth0.htmlId : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "htmlId",
        "hash": {},
        "data": data
      }) : helper)) + "Text\" class=\"default text\">\n      " + escapeExpression((helper = (helper = helpers.placeholder || (depth0 != null ? depth0.placeholder : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "placeholder",
        "hash": {},
        "data": data
      }) : helper)) + "\n    </div>\n";
    },
    "13": function _(depth0, helpers, partials, data) {
      var stack1,
        buffer = "";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.text : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(7, data),
        "inverse": this.program(14, data),
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer;
    },
    "14": function _(depth0, helpers, partials, data) {
      var stack1,
        buffer = "";
      stack1 = helpers.unless.call(depth0, depth0 != null ? depth0.iconOnly : depth0, {
        "name": "unless",
        "hash": {},
        "fn": this.program(15, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer;
    },
    "15": function _(depth0, helpers, partials, data) {
      var helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression;
      return "  <div id=\"" + escapeExpression((helper = (helper = helpers.htmlId || (depth0 != null ? depth0.htmlId : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "htmlId",
        "hash": {},
        "data": data
      }) : helper)) + "Text\" class=\"default text\">\n    " + escapeExpression((helper = (helper = helpers.placeholder || (depth0 != null ? depth0.placeholder : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "placeholder",
        "hash": {},
        "data": data
      }) : helper)) + "\n  </div>\n";
    },
    "17": function _(depth0, helpers, partials, data) {
      return "    <ui name=\"input\"></ui>\n";
    },
    "compiler": [6, ">= 2.0.0-beta.1"],
    "main": function main(depth0, helpers, partials, data) {
      var stack1,
        helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression,
        buffer = "<div id=\"" + escapeExpression((helper = (helper = helpers.htmlId || (depth0 != null ? depth0.htmlId : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
          "name": "htmlId",
          "hash": {},
          "data": data
        }) : helper)) + "Button\" tabindex=\"0\" role=\"button\" aria-label=\"clear\" class=\"ui clear button inline\">Clear</div>\n";
      stack1 = helpers.unless.call(depth0, depth0 != null ? depth0.iconRight : depth0, {
        "name": "unless",
        "hash": {},
        "fn": this.program(1, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.header : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(4, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      stack1 = helpers.unless.call(depth0, depth0 != null ? depth0.iconTop : depth0, {
        "name": "unless",
        "hash": {},
        "fn": this.program(6, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.iconRight : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(1, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.iconTop : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(13, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += "<ul id=\"" + escapeExpression((helper = (helper = helpers.htmlId || (depth0 != null ? depth0.htmlId : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "htmlId",
        "hash": {},
        "data": data
      }) : helper)) + "Menu\" class=\"menu\" role=\"listbox\">\n";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.input : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(17, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer + "</ul>\n";
    },
    "useData": true
  });
  this["Handlebars"]["UIKit"]["dropdown.itemview"] = Handlebars.template({
    "1": function _(depth0, helpers, partials, data) {
      var stack1,
        helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression,
        buffer = "  <i class=\"" + escapeExpression((helper = (helper = helpers.icon || (depth0 != null ? depth0.icon : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
          "name": "icon",
          "hash": {},
          "data": data
        }) : helper)) + " ";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.fluid : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(2, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer + " icon\" aria-hidden=\"true\"></i>\n";
    },
    "2": function _(depth0, helpers, partials, data) {
      return "right floated";
    },
    "4": function _(depth0, helpers, partials, data) {
      var helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression;
      return "<div class=\"ui label circular empty " + escapeExpression((helper = (helper = helpers.color || (depth0 != null ? depth0.color : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "color",
        "hash": {},
        "data": data
      }) : helper)) + "\" aria-hidden=\"true\"></div>";
    },
    "6": function _(depth0, helpers, partials, data) {
      var stack1,
        helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression,
        buffer = "  <span class=\"";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.fluid : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(2, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer + " description\">" + escapeExpression((helper = (helper = helpers.description || (depth0 != null ? depth0.description : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "description",
        "hash": {},
        "data": data
      }) : helper)) + "</span>\n";
    },
    "8": function _(depth0, helpers, partials, data) {
      var helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression;
      return "  <div class=\"menu " + escapeExpression((helper = (helper = helpers.menuDirection || (depth0 != null ? depth0.menuDirection : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "menuDirection",
        "hash": {},
        "data": data
      }) : helper)) + "\"></div>\n";
    },
    "compiler": [6, ">= 2.0.0-beta.1"],
    "main": function main(depth0, helpers, partials, data) {
      var stack1,
        helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression,
        buffer = "";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.icon : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(1, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.color : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(4, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += escapeExpression((helper = (helper = helpers.text || (depth0 != null ? depth0.text : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "text",
        "hash": {},
        "data": data
      }) : helper)) + "\n";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.description : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(6, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.hasChildren : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(8, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer;
    },
    "useData": true
  });
  this["Handlebars"]["UIKit"]["error_helper"] = Handlebars.template({
    "1": function _(depth0, helpers, partials, data) {
      var helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression;
      return "    <div class=\"sub header red\">" + escapeExpression((helper = (helper = helpers.subText || (depth0 != null ? depth0.subText : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "subText",
        "hash": {},
        "data": data
      }) : helper)) + "</div>\n";
    },
    "compiler": [6, ">= 2.0.0-beta.1"],
    "main": function main(depth0, helpers, partials, data) {
      var stack1,
        helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression,
        buffer = "<i class=\"ban icon\"></i>\n<div class=\"content\">\n  " + escapeExpression((helper = (helper = helpers.text || (depth0 != null ? depth0.text : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
          "name": "text",
          "hash": {},
          "data": data
        }) : helper)) + "\n";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.subText : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(1, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer + "</div>";
    },
    "useData": true
  });
  this["Handlebars"]["UIKit"]["form.field"] = Handlebars.template({
    "1": function _(depth0, helpers, partials, data) {
      var helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression;
      return "  <label>" + escapeExpression((helper = (helper = helpers.text || (depth0 != null ? depth0.text : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "text",
        "hash": {},
        "data": data
      }) : helper)) + "</label>\n";
    },
    "compiler": [6, ">= 2.0.0-beta.1"],
    "main": function main(depth0, helpers, partials, data) {
      var stack1;
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.text : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(1, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        return stack1;
      } else {
        return '';
      }
    },
    "useData": true
  });
  this["Handlebars"]["UIKit"]["header"] = Handlebars.template({
    "1": function _(depth0, helpers, partials, data) {
      var stack1,
        helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression,
        buffer = "  <i class=\"icon " + escapeExpression((helper = (helper = helpers.icon || (depth0 != null ? depth0.icon : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
          "name": "icon",
          "hash": {},
          "data": data
        }) : helper)) + "\"></i>\n  <div class=\"content\">\n    " + escapeExpression((helper = (helper = helpers.text || (depth0 != null ? depth0.text : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
          "name": "text",
          "hash": {},
          "data": data
        }) : helper)) + "\n";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.subText : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(2, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer + "  </div>\n";
    },
    "2": function _(depth0, helpers, partials, data) {
      var helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression;
      return "      <div class=\"sub header\">" + escapeExpression((helper = (helper = helpers.subText || (depth0 != null ? depth0.subText : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "subText",
        "hash": {},
        "data": data
      }) : helper)) + "</div>\n";
    },
    "4": function _(depth0, helpers, partials, data) {
      var stack1,
        helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression,
        buffer = "  " + escapeExpression((helper = (helper = helpers.text || (depth0 != null ? depth0.text : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
          "name": "text",
          "hash": {},
          "data": data
        }) : helper)) + "\n";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.subText : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(5, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer;
    },
    "5": function _(depth0, helpers, partials, data) {
      var helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression;
      return "    <div class=\"sub header\">" + escapeExpression((helper = (helper = helpers.subText || (depth0 != null ? depth0.subText : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "subText",
        "hash": {},
        "data": data
      }) : helper)) + "</div>\n";
    },
    "compiler": [6, ">= 2.0.0-beta.1"],
    "main": function main(depth0, helpers, partials, data) {
      var stack1,
        buffer = "";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.icon : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(1, data),
        "inverse": this.program(4, data),
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer;
    },
    "useData": true
  });
  this["Handlebars"]["UIKit"]["input.counter"] = Handlebars.template({
    "compiler": [6, ">= 2.0.0-beta.1"],
    "main": function main(depth0, helpers, partials, data) {
      return "<ui name=\"input\" />\n<div class=\"ui vertical buttons\">\n  <ui name=\"increment\" />\n  <ui name=\"decrement\" />\n</div>";
    },
    "useData": true
  });
  this["Handlebars"]["UIKit"]["input"] = Handlebars.template({
    "1": function _(depth0, helpers, partials, data) {
      var stack1,
        buffer = "";
      stack1 = helpers.unless.call(depth0, depth0 != null ? depth0.labelRight : depth0, {
        "name": "unless",
        "hash": {},
        "fn": this.program(2, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer;
    },
    "2": function _(depth0, helpers, partials, data) {
      var helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression;
      return "  <div class=\"ui label\">" + escapeExpression((helper = (helper = helpers.label || (depth0 != null ? depth0.label : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "label",
        "hash": {},
        "data": data
      }) : helper)) + "</div>\n";
    },
    "4": function _(depth0, helpers, partials, data) {
      var stack1,
        buffer = "";
      stack1 = helpers.unless.call(depth0, depth0 != null ? depth0.buttonRight : depth0, {
        "name": "unless",
        "hash": {},
        "fn": this.program(5, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer;
    },
    "5": function _(depth0, helpers, partials, data) {
      return "  <ui name=\"button\" />\n";
    },
    "7": function _(depth0, helpers, partials, data) {
      var stack1,
        helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression,
        buffer = "<textarea name=\"" + escapeExpression((helper = (helper = helpers.name || (depth0 != null ? depth0.name : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
          "name": "name",
          "hash": {},
          "data": data
        }) : helper)) + "\" rows=\"" + escapeExpression((helper = (helper = helpers.rowCount || (depth0 != null ? depth0.rowCount : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
          "name": "rowCount",
          "hash": {},
          "data": data
        }) : helper)) + "\" ";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.readonly : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(8, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer + ">" + escapeExpression((helper = (helper = helpers.value || (depth0 != null ? depth0.value : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "value",
        "hash": {},
        "data": data
      }) : helper)) + "</textarea>\n";
    },
    "8": function _(depth0, helpers, partials, data) {
      return "readonly=\"true\"";
    },
    "10": function _(depth0, helpers, partials, data) {
      var stack1,
        helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression,
        buffer = "<input type=\"" + escapeExpression((helper = (helper = helpers.inputType || (depth0 != null ? depth0.inputType : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
          "name": "inputType",
          "hash": {},
          "data": data
        }) : helper)) + "\" placeholder=\"" + escapeExpression((helper = (helper = helpers.placeholder || (depth0 != null ? depth0.placeholder : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
          "name": "placeholder",
          "hash": {},
          "data": data
        }) : helper)) + "\" value=\"" + escapeExpression((helper = (helper = helpers.value || (depth0 != null ? depth0.value : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
          "name": "value",
          "hash": {},
          "data": data
        }) : helper)) + "\" name=\"" + escapeExpression((helper = (helper = helpers.name || (depth0 != null ? depth0.name : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
          "name": "name",
          "hash": {},
          "data": data
        }) : helper)) + "\" ";
      stack1 = helpers.unless.call(depth0, depth0 != null ? depth0.inputAutocomplete : depth0, {
        "name": "unless",
        "hash": {},
        "fn": this.program(11, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += " ";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.readonly : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(8, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer + ">\n";
    },
    "11": function _(depth0, helpers, partials, data) {
      return "autocomplete=\"off\"";
    },
    "13": function _(depth0, helpers, partials, data) {
      var helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression;
      return "  <i class=\"" + escapeExpression((helper = (helper = helpers.icon || (depth0 != null ? depth0.icon : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "icon",
        "hash": {},
        "data": data
      }) : helper)) + " icon\"></i>\n";
    },
    "15": function _(depth0, helpers, partials, data) {
      var stack1,
        buffer = "";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.labelRight : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(2, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer;
    },
    "17": function _(depth0, helpers, partials, data) {
      var stack1,
        buffer = "";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.buttonRight : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(5, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer;
    },
    "compiler": [6, ">= 2.0.0-beta.1"],
    "main": function main(depth0, helpers, partials, data) {
      var stack1,
        buffer = "";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.label : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(1, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.button : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(4, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += "\n";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.multiLine : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(7, data),
        "inverse": this.program(10, data),
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.icon : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(13, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.label : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(15, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.button : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(17, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer;
    },
    "useData": true
  });
  this["Handlebars"]["UIKit"]["instant.notification"] = Handlebars.template({
    "1": function _(depth0, helpers, partials, data) {
      var helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression;
      return "    <td class=\"icon-column\">\n      <i class=\"icon " + escapeExpression((helper = (helper = helpers.icon || (depth0 != null ? depth0.icon : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "icon",
        "hash": {},
        "data": data
      }) : helper)) + " " + escapeExpression((helper = (helper = helpers.iconColor || (depth0 != null ? depth0.iconColor : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "iconColor",
        "hash": {},
        "data": data
      }) : helper)) + "\"></i>\n    </td>\n";
    },
    "3": function _(depth0, helpers, partials, data) {
      var stack1,
        helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        buffer = "<div class=\"sub header\">";
      stack1 = (helper = (helper = helpers.details || (depth0 != null ? depth0.details : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "details",
        "hash": {},
        "data": data
      }) : helper);
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer + "</div>";
    },
    "compiler": [6, ">= 2.0.0-beta.1"],
    "main": function main(depth0, helpers, partials, data) {
      var stack1,
        helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        buffer = "<table role=\"presentation\">\n  <tr>\n";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.icon : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(1, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += "    <td class=\"content-column\">\n      <div class=\"ui tiny inverted header\">\n        ";
      stack1 = (helper = (helper = helpers.title || (depth0 != null ? depth0.title : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "title",
        "hash": {},
        "data": data
      }) : helper);
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += "\n        ";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.details : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(3, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer + "\n      </div>\n    </td>\n    <td class=\"actions-column\"></td>\n  </tr>\n</table>\n";
    },
    "useData": true
  });
  this["Handlebars"]["UIKit"]["label"] = Handlebars.template({
    "1": function _(depth0, helpers, partials, data) {
      var helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression;
      return "    <i class=\"" + escapeExpression((helper = (helper = helpers.icon || (depth0 != null ? depth0.icon : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "icon",
        "hash": {},
        "data": data
      }) : helper)) + " icon\"></i>\n";
    },
    "3": function _(depth0, helpers, partials, data) {
      var helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression;
      return "  <div class=\"detail\">" + escapeExpression((helper = (helper = helpers.detail || (depth0 != null ? depth0.detail : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "detail",
        "hash": {},
        "data": data
      }) : helper)) + "</div>\n";
    },
    "5": function _(depth0, helpers, partials, data) {
      return "  <i class=\"close icon\" tabindex=\"0\"></i>\n";
    },
    "compiler": [6, ">= 2.0.0-beta.1"],
    "main": function main(depth0, helpers, partials, data) {
      var stack1,
        helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression,
        buffer = "";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.icon : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(1, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += escapeExpression((helper = (helper = helpers.text || (depth0 != null ? depth0.text : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "text",
        "hash": {},
        "data": data
      }) : helper)) + "\n";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.detail : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(3, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.closeable : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(5, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer;
    },
    "useData": true
  });
  this["Handlebars"]["UIKit"]["list.item"] = Handlebars.template({
    "1": function _(depth0, helpers, partials, data) {
      return "  <ui name=\"rightContainer\" />\n";
    },
    "3": function _(depth0, helpers, partials, data) {
      var helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression;
      return "  <i class=\"" + escapeExpression((helper = (helper = helpers.icon || (depth0 != null ? depth0.icon : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "icon",
        "hash": {},
        "data": data
      }) : helper)) + " icon\"></i>\n";
    },
    "5": function _(depth0, helpers, partials, data) {
      var helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression;
      return "  <img src=\"" + escapeExpression((helper = (helper = helpers.image || (depth0 != null ? depth0.image : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "image",
        "hash": {},
        "data": data
      }) : helper)) + "\" alt=\"" + escapeExpression((helper = (helper = helpers.imageAlt || (depth0 != null ? depth0.imageAlt : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "imageAlt",
        "hash": {},
        "data": data
      }) : helper)) + "\" class=\"ui image " + escapeExpression((helper = (helper = helpers.imageClass || (depth0 != null ? depth0.imageClass : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "imageClass",
        "hash": {},
        "data": data
      }) : helper)) + "\">\n";
    },
    "7": function _(depth0, helpers, partials, data) {
      var helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression;
      return "  <div class=\"header\">" + escapeExpression((helper = (helper = helpers.header || (depth0 != null ? depth0.header : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "header",
        "hash": {},
        "data": data
      }) : helper)) + "</div>\n";
    },
    "9": function _(depth0, helpers, partials, data) {
      var stack1,
        helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression,
        buffer = "    <a ";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.linkHref : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(10, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer + " class=\"description\">" + escapeExpression((helper = (helper = helpers.text || (depth0 != null ? depth0.text : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "text",
        "hash": {},
        "data": data
      }) : helper)) + "</a>\n";
    },
    "10": function _(depth0, helpers, partials, data) {
      var helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression;
      return "href=\"" + escapeExpression((helper = (helper = helpers.linkHref || (depth0 != null ? depth0.linkHref : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "linkHref",
        "hash": {},
        "data": data
      }) : helper)) + "\"";
    },
    "12": function _(depth0, helpers, partials, data) {
      var helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression;
      return "    <div class=\"description\">" + escapeExpression((helper = (helper = helpers.text || (depth0 != null ? depth0.text : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "text",
        "hash": {},
        "data": data
      }) : helper)) + "</div>\n";
    },
    "compiler": [6, ">= 2.0.0-beta.1"],
    "main": function main(depth0, helpers, partials, data) {
      var stack1,
        buffer = "";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.useRightContainer : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(1, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.icon : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(3, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.image : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(5, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += "<div class=\"content\">\n";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.header : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(7, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.link : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(9, data),
        "inverse": this.program(12, data),
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer + "</div>";
    },
    "useData": true
  });
  this["Handlebars"]["UIKit"]["list.navigation"] = Handlebars.template({
    "compiler": [6, ">= 2.0.0-beta.1"],
    "main": function main(depth0, helpers, partials, data) {
      return "<div class=\"table-container\"></div>";
    },
    "useData": true
  });
  this["Handlebars"]["UIKit"]["loader"] = Handlebars.template({
    "compiler": [6, ">= 2.0.0-beta.1"],
    "main": function main(depth0, helpers, partials, data) {
      var helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression;
      return escapeExpression((helper = (helper = helpers.text || (depth0 != null ? depth0.text : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "text",
        "hash": {},
        "data": data
      }) : helper));
    },
    "useData": true
  });
  this["Handlebars"]["UIKit"]["menu"] = Handlebars.template({
    "1": function _(depth0, helpers, partials, data) {
      return "  <div class=\"ui page grid\">\n    <div class=\"column\">\n";
    },
    "3": function _(depth0, helpers, partials, data) {
      return "    <div class=\"right menu\"></div>\n";
    },
    "5": function _(depth0, helpers, partials, data) {
      return "  <div class=\"title\">\n    <ui name=\"title\"></ui>\n  </div>\n";
    },
    "7": function _(depth0, helpers, partials, data) {
      return "    </div>\n  </div>\n";
    },
    "compiler": [6, ">= 2.0.0-beta.1"],
    "main": function main(depth0, helpers, partials, data) {
      var stack1,
        helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression,
        buffer = "\n";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.page : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(1, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += "\n\n<div role=\"" + escapeExpression((helper = (helper = helpers.role || (depth0 != null ? depth0.role : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "role",
        "hash": {},
        "data": data
      }) : helper)) + "\" class=\"menu-container\">\n";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.rightAligned : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(3, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += "</div>\n\n\n";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.title : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(5, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += "\n";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.page : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(7, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer;
    },
    "useData": true
  });
  this["Handlebars"]["UIKit"]["menu.image.item"] = Handlebars.template({
    "1": function _(depth0, helpers, partials, data) {
      var helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression;
      return "width=\"" + escapeExpression((helper = (helper = helpers.width || (depth0 != null ? depth0.width : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "width",
        "hash": {},
        "data": data
      }) : helper)) + "\"";
    },
    "3": function _(depth0, helpers, partials, data) {
      var helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression;
      return "height=\"" + escapeExpression((helper = (helper = helpers.height || (depth0 != null ? depth0.height : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "height",
        "hash": {},
        "data": data
      }) : helper)) + "\"";
    },
    "compiler": [6, ">= 2.0.0-beta.1"],
    "main": function main(depth0, helpers, partials, data) {
      var stack1,
        helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression,
        buffer = "<img src=\"" + escapeExpression((helper = (helper = helpers.image || (depth0 != null ? depth0.image : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
          "name": "image",
          "hash": {},
          "data": data
        }) : helper)) + "\" alt=\"" + escapeExpression((helper = (helper = helpers.alt || (depth0 != null ? depth0.alt : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
          "name": "alt",
          "hash": {},
          "data": data
        }) : helper)) + "\" ";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.width : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(1, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += " ";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.height : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(3, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer + ">";
    },
    "useData": true
  });
  this["Handlebars"]["UIKit"]["menu.item"] = Handlebars.template({
    "1": function _(depth0, helpers, partials, data) {
      var helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression;
      return "  <i class=\"" + escapeExpression((helper = (helper = helpers.icon || (depth0 != null ? depth0.icon : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "icon",
        "hash": {},
        "data": data
      }) : helper)) + " icon\"></i>\n";
    },
    "3": function _(depth0, helpers, partials, data) {
      return "  <ui name=\"label\" />\n";
    },
    "5": function _(depth0, helpers, partials, data) {
      var helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression;
      return "  <span class=\"text\">" + escapeExpression((helper = (helper = helpers.text || (depth0 != null ? depth0.text : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "text",
        "hash": {},
        "data": data
      }) : helper)) + "</span>\n";
    },
    "7": function _(depth0, helpers, partials, data) {
      return "  <ui name=\"subMenu\" />\n";
    },
    "compiler": [6, ">= 2.0.0-beta.1"],
    "main": function main(depth0, helpers, partials, data) {
      var stack1,
        buffer = "";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.icon : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(1, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.label : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(3, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      stack1 = helpers.unless.call(depth0, depth0 != null ? depth0.iconOnly : depth0, {
        "name": "unless",
        "hash": {},
        "fn": this.program(5, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.subMenu : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(7, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer;
    },
    "useData": true
  });
  this["Handlebars"]["UIKit"]["message"] = Handlebars.template({
    "1": function _(depth0, helpers, partials, data) {
      return "<i class=\"close icon\"></i>\n";
    },
    "3": function _(depth0, helpers, partials, data) {
      var helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression;
      return "<div class=\"header\">" + escapeExpression((helper = (helper = helpers.header || (depth0 != null ? depth0.header : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "header",
        "hash": {},
        "data": data
      }) : helper)) + "</div>\n";
    },
    "5": function _(depth0, helpers, partials, data) {
      var stack1,
        helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        buffer = "<p>";
      stack1 = (helper = (helper = helpers.text || (depth0 != null ? depth0.text : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "text",
        "hash": {},
        "data": data
      }) : helper);
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer + "</p>\n";
    },
    "compiler": [6, ">= 2.0.0-beta.1"],
    "main": function main(depth0, helpers, partials, data) {
      var stack1,
        buffer = "";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.dismissable : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(1, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += "\n";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.header : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(3, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += "\n";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.text : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(5, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer + "\n<ul class=\"list\"></ul>";
    },
    "useData": true
  });
  this["Handlebars"]["UIKit"]["modal.actions.fluid"] = Handlebars.template({
    "1": function _(depth0, helpers, partials, data) {
      return "inverted";
    },
    "compiler": [6, ">= 2.0.0-beta.1"],
    "main": function main(depth0, helpers, partials, data) {
      var stack1,
        lambda = this.lambda,
        escapeExpression = this.escapeExpression,
        buffer = "<div class=\"ui " + escapeExpression(lambda((stack1 = depth0 != null ? depth0.buttons : depth0) != null ? stack1.length : stack1, depth0)) + " fluid ";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.basic : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(1, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer + " buttons\"></div>";
    },
    "useData": true
  });
  this["Handlebars"]["UIKit"]["modal.content"] = Handlebars.template({
    "1": function _(depth0, helpers, partials, data) {
      var helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression;
      return "  <div class=\"image\">\n    <i class=\"" + escapeExpression((helper = (helper = helpers.icon || (depth0 != null ? depth0.icon : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "icon",
        "hash": {},
        "data": data
      }) : helper)) + " icon\"></i>\n  </div>\n";
    },
    "compiler": [6, ">= 2.0.0-beta.1"],
    "main": function main(depth0, helpers, partials, data) {
      var stack1,
        helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression,
        buffer = "";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.icon : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(1, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer + "<div class=\"description\">" + escapeExpression((helper = (helper = helpers.text || (depth0 != null ? depth0.text : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "text",
        "hash": {},
        "data": data
      }) : helper)) + "</div>";
    },
    "useData": true
  });
  this["Handlebars"]["UIKit"]["modal"] = Handlebars.template({
    "1": function _(depth0, helpers, partials, data) {
      var stack1,
        buffer = "";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.closeIcon : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(2, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer;
    },
    "2": function _(depth0, helpers, partials, data) {
      var helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression;
      return "    <i class=\"" + escapeExpression((helper = (helper = helpers.closeIcon || (depth0 != null ? depth0.closeIcon : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "closeIcon",
        "hash": {},
        "data": data
      }) : helper)) + " icon\" role=\"button\" aria-label=\"close\" tabindex=\"0\"></i>\n";
    },
    "compiler": [6, ">= 2.0.0-beta.1"],
    "main": function main(depth0, helpers, partials, data) {
      var stack1,
        buffer = "";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.closable : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(1, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer + "<ui name=\"header\"></ui>\n<ui name=\"content\"></ui>\n<ui name=\"actions\"></ui>\n";
    },
    "useData": true
  });
  this["Handlebars"]["UIKit"]["modal.header"] = Handlebars.template({
    "compiler": [6, ">= 2.0.0-beta.1"],
    "main": function main(depth0, helpers, partials, data) {
      var helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression;
      return escapeExpression((helper = (helper = helpers.text || (depth0 != null ? depth0.text : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "text",
        "hash": {},
        "data": data
      }) : helper));
    },
    "useData": true
  });
  this["Handlebars"]["UIKit"]["pagination.item"] = Handlebars.template({
    "1": function _(depth0, helpers, partials, data) {
      var helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression;
      return "  <i class=\"" + escapeExpression((helper = (helper = helpers.icon || (depth0 != null ? depth0.icon : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "icon",
        "hash": {},
        "data": data
      }) : helper)) + " icon\"></i>\n";
    },
    "3": function _(depth0, helpers, partials, data) {
      return "go to ";
    },
    "5": function _(depth0, helpers, partials, data) {
      return "  <span class=\"accessibility-text\">, currently selected</span>\n";
    },
    "compiler": [6, ">= 2.0.0-beta.1"],
    "main": function main(depth0, helpers, partials, data) {
      var stack1,
        helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression,
        buffer = "";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.icon : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(1, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += "\n\n<span class=\"accessibility-text\">";
      stack1 = helpers.unless.call(depth0, depth0 != null ? depth0.active : depth0, {
        "name": "unless",
        "hash": {},
        "fn": this.program(3, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += "page</span>\n<span class=\"text\">" + escapeExpression((helper = (helper = helpers.text || (depth0 != null ? depth0.text : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "text",
        "hash": {},
        "data": data
      }) : helper)) + "</span>\n";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.active : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(5, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer;
    },
    "useData": true
  });
  this["Handlebars"]["UIKit"]["popup"] = Handlebars.template({
    "compiler": [6, ">= 2.0.0-beta.1"],
    "main": function main(depth0, helpers, partials, data) {
      return "<ui name=\"content\"></ui>";
    },
    "useData": true
  });
  this["Handlebars"]["UIKit"]["progress"] = Handlebars.template({
    "1": function _(depth0, helpers, partials, data) {
      var helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression;
      return "  <div class=\"label\" tabindex=\"0\">" + escapeExpression((helper = (helper = helpers.text || (depth0 != null ? depth0.text : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "text",
        "hash": {},
        "data": data
      }) : helper)) + "</div>\n";
    },
    "compiler": [6, ">= 2.0.0-beta.1"],
    "main": function main(depth0, helpers, partials, data) {
      var stack1,
        helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression,
        buffer = "<div class=\"bar\" style=\"transition: " + escapeExpression((helper = (helper = helpers.transition || (depth0 != null ? depth0.transition : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
          "name": "transition",
          "hash": {},
          "data": data
        }) : helper)) + "; -webkit-transition: " + escapeExpression((helper = (helper = helpers.transition || (depth0 != null ? depth0.transition : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
          "name": "transition",
          "hash": {},
          "data": data
        }) : helper)) + "; width: " + escapeExpression((helper = (helper = helpers.percent || (depth0 != null ? depth0.percent : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
          "name": "percent",
          "hash": {},
          "data": data
        }) : helper)) + "%;\">\n  <div class=\"progress\"></div>\n</div>\n";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.text : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(1, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer;
    },
    "useData": true
  });
  this["Handlebars"]["UIKit"]["result"] = Handlebars.template({
    "1": function _(depth0, helpers, partials, data) {
      var helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression;
      return "  <div class=\"description\">" + escapeExpression((helper = (helper = helpers.description || (depth0 != null ? depth0.description : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "description",
        "hash": {},
        "data": data
      }) : helper)) + "</div>\n";
    },
    "compiler": [6, ">= 2.0.0-beta.1"],
    "main": function main(depth0, helpers, partials, data) {
      var stack1,
        helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression,
        buffer = "<div class=\"content\">\n  <div class=\"title\">" + escapeExpression((helper = (helper = helpers.text || (depth0 != null ? depth0.text : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
          "name": "text",
          "hash": {},
          "data": data
        }) : helper)) + "</div>\n";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.description : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(1, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer + "</div>";
    },
    "useData": true
  });
  this["Handlebars"]["UIKit"]["step"] = Handlebars.template({
    "1": function _(depth0, helpers, partials, data) {
      var helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression;
      return "<i class=\"" + escapeExpression((helper = (helper = helpers.icon || (depth0 != null ? depth0.icon : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "icon",
        "hash": {},
        "data": data
      }) : helper)) + " icon\"></i>\n";
    },
    "3": function _(depth0, helpers, partials, data) {
      var helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression;
      return escapeExpression((helper = (helper = helpers.text || (depth0 != null ? depth0.text : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "text",
        "hash": {},
        "data": data
      }) : helper)) + "\n";
    },
    "5": function _(depth0, helpers, partials, data) {
      var stack1,
        helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression,
        buffer = "<div class=\"content\">\n	<div class=\"title\">" + escapeExpression((helper = (helper = helpers.title || (depth0 != null ? depth0.title : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
          "name": "title",
          "hash": {},
          "data": data
        }) : helper)) + "</div>\n";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.description : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(6, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer + "</div>\n";
    },
    "6": function _(depth0, helpers, partials, data) {
      var helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression;
      return "	<div class=\"description\">" + escapeExpression((helper = (helper = helpers.description || (depth0 != null ? depth0.description : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "description",
        "hash": {},
        "data": data
      }) : helper)) + "</div>\n";
    },
    "compiler": [6, ">= 2.0.0-beta.1"],
    "main": function main(depth0, helpers, partials, data) {
      var stack1,
        buffer = "";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.icon : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(1, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += "\n";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.text : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(3, data),
        "inverse": this.program(5, data),
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer;
    },
    "useData": true
  });
  this["Handlebars"]["UIKit"]["table.empty"] = Handlebars.template({
    "compiler": [6, ">= 2.0.0-beta.1"],
    "main": function main(depth0, helpers, partials, data) {
      var helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression;
      return "<td colspan=\"" + escapeExpression((helper = (helper = helpers.columns || (depth0 != null ? depth0.columns : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "columns",
        "hash": {},
        "data": data
      }) : helper)) + "\">" + escapeExpression((helper = (helper = helpers.text || (depth0 != null ? depth0.text : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "text",
        "hash": {},
        "data": data
      }) : helper)) + "</td>";
    },
    "useData": true
  });
  this["Handlebars"]["UIKit"]["table"] = Handlebars.template({
    "1": function _(depth0, helpers, partials, data) {
      var stack1,
        helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression,
        buffer = "  <caption ";
      stack1 = helpers.unless.call(depth0, depth0 != null ? depth0.showCaption : depth0, {
        "name": "unless",
        "hash": {},
        "fn": this.program(2, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer + ">" + escapeExpression((helper = (helper = helpers.caption || (depth0 != null ? depth0.caption : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "caption",
        "hash": {},
        "data": data
      }) : helper)) + "</caption>\n";
    },
    "2": function _(depth0, helpers, partials, data) {
      return "class=\"accessibility-text\"";
    },
    "4": function _(depth0, helpers, partials, data) {
      var stack1,
        lambda = this.lambda,
        escapeExpression = this.escapeExpression;
      return "<tfoot>\n  <tr>\n    <td colspan=\"" + escapeExpression(lambda((stack1 = depth0 != null ? depth0.columns : depth0) != null ? stack1.length : stack1, depth0)) + "\" class=\"item count\"></td>\n  </tr>\n</tfoot>\n";
    },
    "compiler": [6, ">= 2.0.0-beta.1"],
    "main": function main(depth0, helpers, partials, data) {
      var stack1,
        buffer = "";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.caption : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(1, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += "\n<thead>\n  <tr></tr>\n  <tr class=\"responsive sort\"><th><ui name=\"dropdown\" /></th></tr>\n</thead>\n<tbody></tbody>\n";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.itemCount : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(4, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer;
    },
    "useData": true
  });
  this["Handlebars"]["UIKit"]["table.header"] = Handlebars.template({
    "1": function _(depth0, helpers, partials, data) {
      var helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression;
      return "<button class=\"ui button table-sort-button\" aria-label=\"" + escapeExpression((helper = (helper = helpers.sortButtonAriaLabel || (depth0 != null ? depth0.sortButtonAriaLabel : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "sortButtonAriaLabel",
        "hash": {},
        "data": data
      }) : helper)) + "\">\n";
    },
    "3": function _(depth0, helpers, partials, data) {
      var stack1,
        lambda = this.lambda,
        escapeExpression = this.escapeExpression;
      return "  <span class=\"accessibility-text\">" + escapeExpression(lambda((stack1 = depth0 != null ? depth0.model : depth0) != null ? stack1.text : stack1, depth0)) + "</span>\n";
    },
    "5": function _(depth0, helpers, partials, data) {
      var stack1,
        lambda = this.lambda,
        escapeExpression = this.escapeExpression;
      return "  " + escapeExpression(lambda((stack1 = depth0 != null ? depth0.model : depth0) != null ? stack1.text : stack1, depth0)) + "\n";
    },
    "7": function _(depth0, helpers, partials, data) {
      return "</button>\n";
    },
    "compiler": [6, ">= 2.0.0-beta.1"],
    "main": function main(depth0, helpers, partials, data) {
      var stack1,
        buffer = "";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.sortableColumnHeader : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(1, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += "\n";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.useAccessibilityText : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(3, data),
        "inverse": this.program(5, data),
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += "\n";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.sortableColumnHeader : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(7, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer;
    },
    "useData": true
  });
  this["Handlebars"]["UIKit"]["table.row"] = Handlebars.template({
    "1": function _(depth0, helpers, partials, data) {
      var stack1,
        helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression,
        buffer = "  <td style=\"";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.rowLink : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(2, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += " ";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.width : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(4, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += " ";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.maxWidth : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(6, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += " ";
      stack1 = helpers.unless.call(depth0, depth0 != null ? depth0.selectable : depth0, {
        "name": "unless",
        "hash": {},
        "fn": this.program(8, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += "\" class=\"";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.nowrap : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(10, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.align : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(12, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += " ";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.view : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(14, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += "\" data-column-name=\"" + escapeExpression((helper = (helper = helpers.column || (depth0 != null ? depth0.column : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "column",
        "hash": {},
        "data": data
      }) : helper)) + "\" data-view-index=\"" + escapeExpression((helper = (helper = helpers.index || (depth0 != null ? depth0.index : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "index",
        "hash": {},
        "data": data
      }) : helper)) + "\" ";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.colspan : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(16, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += ">\n  <span>" + escapeExpression((helper = (helper = helpers.value || (depth0 != null ? depth0.value : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "value",
        "hash": {},
        "data": data
      }) : helper)) + "</span>\n  ";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.rowLink : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(18, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer + "\n  </td>\n";
    },
    "2": function _(depth0, helpers, partials, data) {
      return "position: relative;";
    },
    "4": function _(depth0, helpers, partials, data) {
      var helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression;
      return "width: " + escapeExpression((helper = (helper = helpers.width || (depth0 != null ? depth0.width : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "width",
        "hash": {},
        "data": data
      }) : helper));
    },
    "6": function _(depth0, helpers, partials, data) {
      var helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression;
      return "max-width: " + escapeExpression((helper = (helper = helpers.maxWidth || (depth0 != null ? depth0.maxWidth : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "maxWidth",
        "hash": {},
        "data": data
      }) : helper)) + ";";
    },
    "8": function _(depth0, helpers, partials, data) {
      return "cursor: default;";
    },
    "10": function _(depth0, helpers, partials, data) {
      return "nowrap";
    },
    "12": function _(depth0, helpers, partials, data) {
      var helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression;
      return escapeExpression((helper = (helper = helpers.align || (depth0 != null ? depth0.align : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "align",
        "hash": {},
        "data": data
      }) : helper)) + " aligned ";
    },
    "14": function _(depth0, helpers, partials, data) {
      return "view";
    },
    "16": function _(depth0, helpers, partials, data) {
      var helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression;
      return "colspan=\"" + escapeExpression((helper = (helper = helpers.colspan || (depth0 != null ? depth0.colspan : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "colspan",
        "hash": {},
        "data": data
      }) : helper)) + "\"";
    },
    "18": function _(depth0, helpers, partials, data) {
      var helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression;
      return "<a href=\"" + escapeExpression((helper = (helper = helpers.rowLink || (depth0 != null ? depth0.rowLink : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "rowLink",
        "hash": {},
        "data": data
      }) : helper)) + "\" class=\"accessibility-text\" aria-hidden=\"true\" target=\"" + escapeExpression((helper = (helper = helpers.rowLinkTarget || (depth0 != null ? depth0.rowLinkTarget : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "rowLinkTarget",
        "hash": {},
        "data": data
      }) : helper)) + "\" tabindex=\"-1\">Details for this row</a>";
    },
    "compiler": [6, ">= 2.0.0-beta.1"],
    "main": function main(depth0, helpers, partials, data) {
      var stack1,
        buffer = "";
      stack1 = helpers.each.call(depth0, depth0 != null ? depth0.columns : depth0, {
        "name": "each",
        "hash": {},
        "fn": this.program(1, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer;
    },
    "useData": true
  });
  this["Handlebars"]["UIKit"]["table.row.header"] = Handlebars.template({
    "compiler": [6, ">= 2.0.0-beta.1"],
    "main": function main(depth0, helpers, partials, data) {
      var helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression;
      return "<td colspan=\"" + escapeExpression((helper = (helper = helpers.columns || (depth0 != null ? depth0.columns : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "columns",
        "hash": {},
        "data": data
      }) : helper)) + "\">" + escapeExpression((helper = (helper = helpers.text || (depth0 != null ? depth0.text : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "text",
        "hash": {},
        "data": data
      }) : helper)) + "</td>";
    },
    "useData": true
  });
  this["Handlebars"]["UIKit"]["text"] = Handlebars.template({
    "compiler": [6, ">= 2.0.0-beta.1"],
    "main": function main(depth0, helpers, partials, data) {
      var helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression;
      return escapeExpression((helper = (helper = helpers.text || (depth0 != null ? depth0.text : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "text",
        "hash": {},
        "data": data
      }) : helper));
    },
    "useData": true
  });
  this["Handlebars"]["UIKit"]["token"] = Handlebars.template({
    "1": function _(depth0, helpers, partials, data) {
      var helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression;
      return "<i class=\"" + escapeExpression((helper = (helper = helpers.icon || (depth0 != null ? depth0.icon : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "icon",
        "hash": {},
        "data": data
      }) : helper)) + " icon\"></i>\n";
    },
    "3": function _(depth0, helpers, partials, data) {
      var helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression;
      return "<span>" + escapeExpression((helper = (helper = helpers.separator || (depth0 != null ? depth0.separator : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "separator",
        "hash": {},
        "data": data
      }) : helper)) + " </span><div class=\"detail\">" + escapeExpression((helper = (helper = helpers.detail || (depth0 != null ? depth0.detail : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "detail",
        "hash": {},
        "data": data
      }) : helper)) + "</div>";
    },
    "5": function _(depth0, helpers, partials, data) {
      return " <i class=\"close icon\"></i>\n";
    },
    "compiler": [6, ">= 2.0.0-beta.1"],
    "main": function main(depth0, helpers, partials, data) {
      var stack1,
        helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression,
        buffer = "";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.icon : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(1, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += "<div class=\"text\">" + escapeExpression((helper = (helper = helpers.text || (depth0 != null ? depth0.text : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "text",
        "hash": {},
        "data": data
      }) : helper)) + "</div>";
      stack1 = helpers.unless.call(depth0, depth0 != null ? depth0.single : depth0, {
        "name": "unless",
        "hash": {},
        "fn": this.program(3, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += "\n";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.closeable : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(5, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer;
    },
    "useData": true
  });
  this["Handlebars"]["UIKit"]["token.input"] = Handlebars.template({
    "1": function _(depth0, helpers, partials, data) {
      var helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression;
      return "<i class=\"" + escapeExpression((helper = (helper = helpers.icon || (depth0 != null ? depth0.icon : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "icon",
        "hash": {},
        "data": data
      }) : helper)) + " icon\"></i>";
    },
    "compiler": [6, ">= 2.0.0-beta.1"],
    "main": function main(depth0, helpers, partials, data) {
      var stack1,
        helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression,
        buffer = "<div class=\"prompt\">\n  ";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.icon : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(1, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer + "\n  <div class=\"placeholder\">" + escapeExpression((helper = (helper = helpers.placeholder || (depth0 != null ? depth0.placeholder : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "placeholder",
        "hash": {},
        "data": data
      }) : helper)) + "</div>\n  <div class=\"token box\"></div>\n  <div class=\"token input\" contentEditable=\"true\" tabindex=\"0\"></div>\n  <i class=\"token clear remove circle icon\"></i>\n</div>\n<ui name=\"resultsView\"/>";
    },
    "useData": true
  });
  this["Handlebars"]["UIKit"]["tree.item"] = Handlebars.template({
    "1": function _(depth0, helpers, partials, data) {
      var helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression;
      return "    <i class=\"" + escapeExpression((helper = (helper = helpers.icon || (depth0 != null ? depth0.icon : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "icon",
        "hash": {},
        "data": data
      }) : helper)) + " icon\"></i>\n";
    },
    "3": function _(depth0, helpers, partials, data) {
      var stack1,
        helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression,
        buffer = "    <a class=\"text\" ";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.href : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(4, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += " ";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.target : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(6, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer + " tabindex=\"-1\">" + escapeExpression((helper = (helper = helpers.text || (depth0 != null ? depth0.text : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "text",
        "hash": {},
        "data": data
      }) : helper)) + "</a>\n";
    },
    "4": function _(depth0, helpers, partials, data) {
      var helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression;
      return "href=\"" + escapeExpression((helper = (helper = helpers.href || (depth0 != null ? depth0.href : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "href",
        "hash": {},
        "data": data
      }) : helper)) + "\"";
    },
    "6": function _(depth0, helpers, partials, data) {
      var helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression;
      return "target=\"" + escapeExpression((helper = (helper = helpers.target || (depth0 != null ? depth0.target : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "target",
        "hash": {},
        "data": data
      }) : helper)) + "\"";
    },
    "8": function _(depth0, helpers, partials, data) {
      var helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression;
      return "    <span class=\"text\">" + escapeExpression((helper = (helper = helpers.text || (depth0 != null ? depth0.text : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "text",
        "hash": {},
        "data": data
      }) : helper)) + "</span>\n";
    },
    "compiler": [6, ">= 2.0.0-beta.1"],
    "main": function main(depth0, helpers, partials, data) {
      var stack1,
        buffer = "<div class=\"title\" tabindex=\"0\">\n  <i class=\"dropdown icon\" tabindex=\"0\"></i>\n";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.icon : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(1, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.link : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(3, data),
        "inverse": this.program(8, data),
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer + "</div>\n<div class=\"content\"></div>";
    },
    "useData": true
  });
  this["Handlebars"]["UIKit"]["tutorial"] = Handlebars.template({
    "compiler": [6, ">= 2.0.0-beta.1"],
    "main": function main(depth0, helpers, partials, data) {
      var helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression;
      return "<div class=\"spotlight\" style=\"position: absolute; top: 0px; left: 0px; right: 0px; bottom: 0px; z-index: 1;\">\n  <div class=\"full\" style=\"position: absolute; top: 0px; left: 0px; right: 0px; bottom: 0px; background: rgba(0, 0, 0, " + escapeExpression((helper = (helper = helpers.opacity || (depth0 != null ? depth0.opacity : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "opacity",
        "hash": {},
        "data": data
      }) : helper)) + ");\"></div>\n  <div class=\"left\" style=\"position: absolute; top: 0px; left: 0px; bottom: 0px; background: rgba(0, 0, 0, " + escapeExpression((helper = (helper = helpers.opacity || (depth0 != null ? depth0.opacity : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "opacity",
        "hash": {},
        "data": data
      }) : helper)) + ");\"></div>\n  <div class=\"right\" style=\"position: absolute; top: 0px; bottom: 0px; right: 0px; background: rgba(0, 0, 0, " + escapeExpression((helper = (helper = helpers.opacity || (depth0 != null ? depth0.opacity : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "opacity",
        "hash": {},
        "data": data
      }) : helper)) + ");\"></div>\n  <div class=\"top\" style=\"position: absolute; top: 0px; left: 0px; background: rgba(0, 0, 0, " + escapeExpression((helper = (helper = helpers.opacity || (depth0 != null ? depth0.opacity : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "opacity",
        "hash": {},
        "data": data
      }) : helper)) + ");\"></div>\n  <div class=\"bottom\" style=\"position: absolute; bottom: 0px; left: 0px; background: rgba(0, 0, 0, " + escapeExpression((helper = (helper = helpers.opacity || (depth0 != null ? depth0.opacity : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "opacity",
        "hash": {},
        "data": data
      }) : helper)) + ");\"></div>\n</div>\n<div class=\"arrows\" style=\"position: absolute; top: 0px; left: 0px; right: 0px; bottom: 0px; z-index: 1;\">\n  <canvas style=\"position: absolute; top: 0px; left: 0px;\"></canvas>\n</div>\n<div class=\"content\" style=\"position: absolute; top: 0px; left: 0px; right: 0px; bottom: 0px; z-index: 2;\"></div>";
    },
    "useData": true
  });
  this["Handlebars"]["UIKit"]["visual.search"] = Handlebars.template({
    "compiler": [6, ">= 2.0.0-beta.1"],
    "main": function main(depth0, helpers, partials, data) {
      var helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression;
      return "<div class=\"prompt\">\n<p id=\"announcer\" class=\"accessibility-text\" role=\"alert\" aria-atomic=\"true\"></p>\n<p id=\"loading\" class=\"accessibility-text\" role=\"alert\" aria-atomic=\"true\"></p>\n  <i class=\"" + escapeExpression((helper = (helper = helpers.icon || (depth0 != null ? depth0.icon : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "icon",
        "hash": {},
        "data": data
      }) : helper)) + " icon\"></i>\n  <div class=\"placeholder\">" + escapeExpression((helper = (helper = helpers.placeholder || (depth0 != null ? depth0.placeholder : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "placeholder",
        "hash": {},
        "data": data
      }) : helper)) + "</div>\n  <div class=\"token box\"></div>\n  <div class=\"token input\" contentEditable=\"true\"></div>\n  <i role=\"button\" aria-label=\"" + escapeExpression((helper = (helper = helpers.clearButtonAriaLabel || (depth0 != null ? depth0.clearButtonAriaLabel : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "clearButtonAriaLabel",
        "hash": {},
        "data": data
      }) : helper)) + "\" tabindex=\"0\" class=\"token clear remove circle icon\"></i>\n</div>\n<ui name=\"tokenResultsView\" />\n<ui name=\"fieldResultsView\" />\n";
    },
    "useData": true
  });
  this["Handlebars"]["UIKit"]["visual.search.result.footer"] = Handlebars.template({
    "compiler": [6, ">= 2.0.0-beta.1"],
    "main": function main(depth0, helpers, partials, data) {
      var helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression;
      return "<i class=\"count\">" + escapeExpression((helper = (helper = helpers.count || (depth0 != null ? depth0.count : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "count",
        "hash": {},
        "data": data
      }) : helper)) + "</i>\n<span id=\"viewMore\" class=\"description\">" + escapeExpression((helper = (helper = helpers.text || (depth0 != null ? depth0.text : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "text",
        "hash": {},
        "data": data
      }) : helper)) + "</span>";
    },
    "useData": true
  });
  this["Handlebars"]["UIKit"]["visual.search.result"] = Handlebars.template({
    "compiler": [6, ">= 2.0.0-beta.1"],
    "main": function main(depth0, helpers, partials, data) {
      var helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression;
      return "<div class=\"content\">\n  <div class=\"title\">" + escapeExpression((helper = (helper = helpers.text || (depth0 != null ? depth0.text : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "text",
        "hash": {},
        "data": data
      }) : helper)) + "</div>\n</div>";
    },
    "useData": true
  });
  this["Handlebars"]["UIKit"]["visual.search.token"] = Handlebars.template({
    "1": function _(depth0, helpers, partials, data) {
      var helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression;
      return "    <i role=\"button\" aria-label=\"" + escapeExpression((helper = (helper = helpers.removeButtonAriaLabel || (depth0 != null ? depth0.removeButtonAriaLabel : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "removeButtonAriaLabel",
        "hash": {},
        "data": data
      }) : helper)) + " " + escapeExpression((helper = (helper = helpers.text || (depth0 != null ? depth0.text : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "text",
        "hash": {},
        "data": data
      }) : helper)) + "\" tabindex=\"0\" class=\"" + escapeExpression((helper = (helper = helpers.icon || (depth0 != null ? depth0.icon : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "icon",
        "hash": {},
        "data": data
      }) : helper)) + " icon\"></i>\n";
    },
    "3": function _(depth0, helpers, partials, data) {
      return "  <i class=\"close icon\"></i>\n";
    },
    "compiler": [6, ">= 2.0.0-beta.1"],
    "main": function main(depth0, helpers, partials, data) {
      var stack1,
        helper,
        functionType = "function",
        helperMissing = helpers.helperMissing,
        escapeExpression = this.escapeExpression,
        buffer = "";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.icon : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(1, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      buffer += escapeExpression((helper = (helper = helpers.text || (depth0 != null ? depth0.text : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "text",
        "hash": {},
        "data": data
      }) : helper)) + "\n<div class=\"detail\">" + escapeExpression((helper = (helper = helpers.detail || (depth0 != null ? depth0.detail : depth0)) != null ? helper : helperMissing, _typeof(helper) === functionType ? helper.call(depth0, {
        "name": "detail",
        "hash": {},
        "data": data
      }) : helper)) + "</div>\n";
      stack1 = helpers['if'].call(depth0, depth0 != null ? depth0.closeable : depth0, {
        "name": "if",
        "hash": {},
        "fn": this.program(3, data),
        "inverse": this.noop,
        "data": data
      });
      if (stack1 != null) {
        buffer += stack1;
      }
      return buffer;
    },
    "useData": true
  });
  return this["Handlebars"];
});

